function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const payloadPart = token.split(".")[1];
    if (!payloadPart) return null;
    const base64 = payloadPart.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
    const decoded = atob(padded);
    return JSON.parse(decoded) as Record<string, unknown>;
  } catch {
    return null;
  }
}

function rolesFromValue(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.filter((entry): entry is string => typeof entry === "string");
  }

  if (typeof value === "string") {
    return [value];
  }

  return [];
}

function normalizeRoles(roles: string[]): string[] {
  return Array.from(
    new Set(
      roles
        .map((role) => role.trim().toLowerCase())
        .filter(Boolean)
    )
  );
}

export function extractRolesFromClaims(
  claims: Record<string, unknown> | null | undefined,
  configuredClaimKey?: string
): string[] {
  if (!claims) return [];

  const collected: string[] = [];
  const configured = configuredClaimKey?.trim();

  if (configured) {
    collected.push(...rolesFromValue(claims[configured]));
  }

  collected.push(...rolesFromValue(claims.roles));

  for (const [key, value] of Object.entries(claims)) {
    if (key.endsWith("/roles") || key.endsWith(":roles")) {
      collected.push(...rolesFromValue(value));
    }
  }

  return normalizeRoles(collected);
}

export function extractRolesFromAccessToken(
  accessToken: string | null | undefined,
  configuredClaimKey?: string
): string[] {
  if (!accessToken) return [];
  const payload = decodeJwtPayload(accessToken);
  return extractRolesFromClaims(payload, configuredClaimKey);
}
